
















import { Vue, Component, Prop } from "vue-property-decorator";
import { DocAutorizzazioneInfo } from "../../_models/docAutorizzazioneInfo";
import * as images from "../../assets/images";
import * as user from "../../_store/user.module";
import * as temp from "../../_store/temp.module";
import { bus } from "../../main";
//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { router } from "../../_router";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component
export default class AutorizzazioneStudentiPreview extends Vue {
  @Prop() docElements!: any;
  private elements: DocAutorizzazioneInfo;

  constructor() {
    super();
    this.elements = {
      cognomeAllievo: this.docElements.info.cognomeAllievo,
      nomeAllievo: this.docElements.info.nomeAllievo,
      luogoNascitaAllievo: this.docElements.info.luogoNascitaAllievo,
      dataNascitaAllievo: this.docElements.info.dataNascitaAllievo,
      indirizzoAllievo: this.docElements.info.indirizzoAllievo,
      comuneAllievo: this.docElements.info.comuneAllievo,
      provinciaAllievo: this.docElements.info.provinciaAllievo,
      capAllievo: this.docElements.info.capAllievo,
      telefonoAllievo: this.docElements.info.telefonoAllievo,
      emailAllievo: this.docElements.info.emailAllievo,
      classeAllievo: this.docElements.info.classeAllievo,
      cognomeTutore: this.docElements.info.cognomeTutore,
      nomeTutore: this.docElements.info.nomeTutore,
      relazioneParentale: this.docElements.info.relazioneParentale,
      telefonoTutore: this.docElements.info.telefonoTutore,
      indirizzoTutore: this.docElements.info.indirizzoTutore,
      comuneTutore: this.docElements.info.comuneTutore,
      provinciaTutore: this.docElements.info.provinciaTutore,
      capTutore: this.docElements.info.capTutore,
      firmaAllievo: this.docElements.info.firmaAllievo,
      firmaTutore: this.docElements.info.firmaTutore,
      statoAutorizzazione: this.docElements.info.statoAutorizzazione,
      idDoc: this.docElements.info.idDoc,
      dataDocumento: this.docElements.info.dataDocumento,
      codiceFiscaleAllievo: this.docElements.info.codiceFiscaleAllievo,
      statoNascitaAllievo: this.docElements.info.statoNascitaAllievo
    };
  }

  createDoc() {
    var dd = {
      /**--------------------------------------------------------
         * Le immagini di header e footer sono convertite in Base64
         * ed importate dal file Header_Footer.js
         ----------------------------------------------------------*/
      pageSize: "A4",
      // ****** FOOTER *********//
      footer: function(/*currentPage, pageCount*/) {
        return [
          {
            image: images.authFooter,
            width: "560",
            height: "80",
            margin: [20, 0]
          }
        ];
      },
      // ******** HEADER ******** //
      header: function(/*currentPage, pageCount, pageSize*/) {
        // you can apply any logic and return any valid pdfmake element

        return [
          {
            // image: images.authHeader,
            image: images.authHeader,
            width: "525",
            height: "90",
            margin: [35, 0]
          }
        ];
      },

      //******** TESTO DEL DOCUMENTO  ********/
      content: [
        {
          text: "PATTO DI CORRESPONSABILITA'",
          alignment: "center",
          margin: [0, 70, 0, 5],
          bold: true,
          fontSize: 18
        },
        {
          text:
            "Il/La sottoscritto/a studente/ssa dell'ISTITUTO DI ISTRUZIONE SUPERIORE 'G. Vallauri' di FOSSANO:",
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          table: {
            widths: [100, "*"],
            body: [
              [
                { text: "Cognome", style: "tableTitle" },
                { text: this.elements.cognomeAllievo, style: "tableText" }
              ],
              [
                { text: "Nome", style: "tableTitle" },
                { text: this.elements.nomeAllievo, style: "tableText" }
              ],
              [
                { text: "Nato/a a", style: "tableTitle" },
                { text: this.elements.luogoNascitaAllievo + "(" + this.elements.statoNascitaAllievo + ")", style: "tableText" }
              ],
              [
                { text: "Nato/a il", style: "tableTitle" },
                { text: this.elements.dataNascitaAllievo, style: "tableText" }
              ],
              [
                { text: "Indirizzo di residenza", style: "tableTitle" },
                { text: this.elements.indirizzoAllievo, style: "tableText" }
              ],
              [
                { text: "Codice Fiscale", style: "tableTitle" },
                { text: this.elements.codiceFiscaleAllievo, style: "tableText" }
              ],
              [
                { text: "Telefono", style: "tableTitle" },
                { text: this.elements.telefonoAllievo, style: "tableText" }
              ],
              [
                { text: "e-mail istituzionale", style: "tableTitle" },
                { text: this.elements.emailAllievo, style: "tableText" }
              ],
              [
                { text: "Classe", style: "tableTitle" },
                { text: this.elements.classeAllievo, style: "tableText" }
              ]
            ]
          }
        },
        {
          text: "DICHIARA",
          bold: true,
          alignment: "center",
          margin: [0, 10, 0, 0]
        },
        {
          text: "di essere a conoscenza che:",
          style: "bodyText"
        },
        {
          ul: [
            {
              text:
                "le attività che andrà a svolgere costituiscono parte integrante del Progetto Formativo;",
              style: "bodyText"
            },
            {
              text:
                "la partecipazione al progetto di Stage Estivo non comporta alcun legame diretto tra il sottoscritto e la struttura Ospitante in questione e che ogni rapporto con la struttura Ospitante stessa cesserà al termine di questo periodo;",
              style: "bodyText"
            },
            {
              text:
                "delle norme comportamentali previste dal C.C.N.L., delle norme antinfortunistiche e di quelle in materia di privacy;",
              style: "bodyText"
            },
            {
              text:
                "spetta al Tutor esterno informare in merito ai rischi Aziendali specifici in materia di sicurezza sul la-voro, di cui al D.Lgs. 81/08 e successive modificazioni;",
              style: "bodyText"
            },
            {
              text:
                "durante il periodo di Stage è Soggetto a quanto stabilito nel regolamento nonché alle regole di comportamento, funzionali e organizzative della struttura Ospitante;",
              style: "bodyText"
            },
            {
              text:
                "nel caso si dovessero verificare episodi di particolare gravità, in accordo con la struttura Ospitante si procederà in qualsiasi momento alla sospensione dell'esperienza di FSL estiva;",
              style: "bodyText"
            },
            {
              text:
                "nessun compenso o indennizzo di qualsiasi natura gli è dovuto in conseguenza della sua partecipa-zione al programma in oggetto;",
              style: "bodyText"
            },
            {
              text:
                "l'esperienza di Stage Estivo non comporta nessun impegno di assunzione presente o futuro da parte della struttura Ospitante;",
              style: "bodyText"
            },
            {
              text:
                "delle coperture assicurative sia per i trasferimenti alla sede di svolgimento dello Stage che per la permanenza nella struttura Ospitante;",
              style: "bodyText"
            }
          ]
        },
        {
          text: "SI IMPEGNA",
          bold: true,
          alignment: "center",
          margin: [0, 10, 0, 10]
        },
        {
          text:
            "ad assumere comportamenti corretti e responsabili sotto tutti gli aspetti, ed in particolare:",
          style: "bodyText"
        },
        {
          ul: [
            {
              text:
                "a svolgere le attività previste dal Progetto Formativo personalizzato;",
              style: "bodyText"
            },
            {
              text:
                "a rispettare le norme in materia di igiene, sicurezza e salute sui luoghi di lavoro, nonché tutte le di-sposizioni, istruzioni, prescrizioni, regolamenti interni previsti a tale scopo, nonché le norme in ma-teria di privacy;",
              style: "bodyText"
            },
            {
              text:
                "a mantenere la necessaria riservatezza per quanto attiene ai dati, informazioni o conoscenze in merito a processi produttivi e prodotti, acquisiti durante lo svolgimento dell’attività formativa in contesto lavorativo;",
              style: "bodyText"
            },
            {
              text:
                "a seguire le indicazioni dei due Tutor e a fare riferimento ad essi per qualsiasi esigenza di tipo or-ganizzativo o altre evenienze;",
              style: "bodyText"
            }
          ],
          pageBreak: "after"
        },
        {
          ul: [
            {
              text:
                "a rispettare gli obblighi di cui al D.Lgs. 81/2008, art. 20;",
              style: "bodyText"
            },
            {
              text:
                "ad informare preventivamente l’Azienda Ospitante qualora presenti particolari esigenze sanitarie;",
              style: "bodyText"
            },
            {
              text:
                "a garantire una regolare presenza e puntualità secondo gli orari stabiliti indipendentemente dall’ubicazione del luogo di lavoro;",
              style: "bodyText"
            },
            {
              text:
                "ad avvisare tempestivamente sia la struttura Ospitante che l'istituzione scolastica (nella persona del Tutor scolastico, preferibilmente via mail) in caso di assenze, ritardi, cambi orario o altre varia-zioni ed a presentare idonea certificazione in caso di malattia.",
              style: "bodyText"
            }
          ],
          margin: [0, 70, 0, 5]
        },
        {
          text: "FOSSANO lì, " + this.elements.dataDocumento,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text: "Firmato lo/la studente/ssa:" + this.elements.nomeAllievo + " " + this.elements.cognomeAllievo,
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          image: this.elements.firmaAllievo,
          width: 200,
          // margin: [10, 0]
        },
        {
          text:
            "Il/La sottoscritto/a " +
            this.elements.nomeTutore + " " + this.elements.cognomeTutore +
            " in qualità di Soggetto esercente la patria potestà del-lo/a studente/ssa, dichiara di aver preso visione di quanto riportato nel presente patto e di autorizzarlo/a a partecipare alle attività previste dal Progetto Formativo.",
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          text: "Firmato il Soggetto esercente la patria potestà: " + this.elements.nomeTutore + " " + this.elements.cognomeTutore,
          style: "bodyText"
        },
        {
          image: this.elements.firmaTutore,
          width: 200,
          // margin: [20, 0]
        },
        {
          text: "Per l'Istituzione Scolastica – Soggetto Promotore",
          style: "bodyText",
          margin: [0, 10, 0, 10]
        },
        {
          image: images.firmaVallauri,
          width: 200,
          margin: [20, 0]
        }
      ],
      styles: {
        bodyText: {
          fontSize: 10,
          justified: true
        },
        tableTitle: {
          fontSize: 10,
          bold: "true",
          alignment: "right"
        },
        tableText: {
          fontSize: 8
        }
      }
    };
    // pdfMake.createPdf(dd).download("prova.pdf");
    // pdfMake.createPdf(dd).open();
    const pdfDocGenerator = pdfMake.createPdf(dd);
    pdfDocGenerator.getDataUrl(function(dataUrl: any) {
      const targetElement = document.querySelector("#iframeContainer");
      const embed = document.createElement("embed");
      embed.src = dataUrl;
      embed.width = "1000";
      embed.height = "700";
      if (targetElement !== null) {
        targetElement.appendChild(embed);
      }
    });
  }

  close() {
    bus.$emit("closeDocPreviewDialog");
    router.push({
      name: "moduliStudente",
      params: {}
    });
  }

  save() {
    if (this.docElements.info.idDoc === 0) {
      var studentInfo = user.readStudentInfo(this["$store"]);
      var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
      var payload = {
        info: this.elements,
        idAllievo: studentInfo.idUtente,
        idAnnoScolastico: idAnnoScolastico,
        idIstituto: studentInfo.codEntità
      };
      user
        .dispatchAuthorizationDoc(this["$store"], payload)
        .then(() => {
          bus.$emit("successfullOperation", "Documento inviato con successo");
          this["$router"].push("/moduliStudente");
        })
        .catch(error => {
          if (error.response.status === 401) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    } else {
      user
        .dispatchUpdateAutorizzazioneStudentiDoc(this["$store"], this.elements)
        .then(() => {
          bus.$emit("successfullOperation", "Documento inviato con successo");
          this["$router"].push("/moduliStudente");
        })
        .catch(error => {
          if (error.response.status === 401) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", "Errore nell'invio del documento");
          }
        });
    }
  }
  created() {
    this.createDoc();
  }
}
